module.exports = __webpack_public_path__ + "img/carn_logo.9557de72.png";